import { AppBundle } from 'api/optimalprint-sdk.d';
import MinimalProductPrice from 'components/Common/Prices/MinimalProductPrice/MinimalProductPrice';
import React, { FC } from 'react';
import cn from 'classnames';
import { CatalogItem } from 'store/landing/types';
import PricesSize from 'components/Common/Prices/ProductPrice/types';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './LPCatalogItem.module.scss';

export type LPCatalogItemProps = {
  image: string;
  imageMobile: string;
  name: string;
  abstractProduct: AppBundle.Api.Entity.App.V1.IAbstractProduct;
  referenceUrl: string;
  theme?: string;
} & Partial<Omit<CatalogItem, 'abstractProduct'>>;

const LPCatalogItem: FC<LPCatalogItemProps> = ({
  image,
  imageMobile,
  name,
  abstractProduct,
  referenceUrl,
  theme,
  badgeText,
}) => {
  const { isDesktopDevice } = useLandingPageContext();
  const imageSrc = isDesktopDevice ? image : imageMobile;
  const handleItemClick = () => {
    if (referenceUrl) {
      window.location.href = referenceUrl;
    }
  };
  if (!abstractProduct) {
    return null;
  }
  return (
    <div className={cn(styles.lpCatalogItem, styles[`theme-${theme}`])} onClick={handleItemClick}>
      <div className={styles.content}>
        <div className={styles.lpCatalogItemImage} style={{ backgroundImage: `url(${imageSrc})` }} />
        <div className={styles.lpCatalogItemDetails}>
          <h2 className={styles.lpCatalogItemName}>{name}</h2>
          {badgeText && <span className={styles.badgeText}>{badgeText}</span>}
          <div className={styles.lpCatalogItemPrice}>
            <MinimalProductPrice
              categoryId={abstractProduct.categoryId}
              quantity={1}
              product={abstractProduct}
              size={PricesSize.sm}
              theme="landing"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LPCatalogItem;
